import * as React from 'react';
import { Box, Heading, Image, Text } from '@wix/design-system';
function ReviewAppHeaderMobile({ appName, appIconSrc, t, }) {
    const headerTitle = t('review-app.header-title');
    const headerDescription = t('review-app.header-description', { appName });
    return (React.createElement(Box, { direction: "vertical" },
        React.createElement(Heading, { appearance: "H3" }, headerTitle),
        React.createElement(Box, { maxWidth: "450px", marginBottom: "10px", marginTop: "18px", direction: "horizontal", verticalAlign: "middle" },
            React.createElement(Box, { width: "48px", height: "48px", marginRight: "12px" },
                React.createElement(Image, { src: appIconSrc, alt: `${appName} icon` })),
            React.createElement(Text, { weight: "bold" }, appName)),
        React.createElement(Text, { size: "small" }, headerDescription)));
}
export { ReviewAppHeaderMobile };
//# sourceMappingURL=review-app-header-mobile.js.map